import React from 'react'
import { Card, Spin, Table, Button, Popconfirm, Tooltip, Icon } from 'antd'
import moment from 'moment'
import { users, tranzila } from '@services/api'
import { alertPopup } from '@utils/popup'
import { stoErrKeyText } from '@pages/Tranzila/stoErrors'

class SubscriptionHistory extends React.Component<any, any> {
    statuses = {
        CANCELED: { text: 'מבוטל', color: '', weight: '' },
        ACTIVE: { text: 'פעיל', color: 'green', weight: 'bold' },
        BLOCKED: { text: 'חסום', color: 'red', weight: '' }
    }

    constructor(props) {
        super(props)
        this.state = {
            list: [],
            qDate: '',
            showRecoveryOption: props.showRecoveryOption,
            refreshHistory: props.refreshHistory,
            loading: true,
            loadingStoRow: 0
        }
    }

    componentDidMount() {
        this.getHistory()
    }

    componentDidUpdate(prevProps) {
        const prevId = prevProps.clientInfo && prevProps.clientInfo.id
        const currentId = this.props.clientInfo && this.props.clientInfo.id
        if (prevId !== currentId) {
            this.setState({ loading: true }, () => this.getHistory())
            return
        }
        if (prevProps.purchaseStatusVersion !== this.props.purchaseStatusVersion) {
            this.getHistory()
            this.props.resetRefreshHistory()
        }
        if (prevProps.refreshHistory !== this.props.refreshHistory) {
            this.getHistory()
            this.props.resetRefreshHistory()
        }
        const { clientInfo, loadingSto } = this.props
        if (prevProps.loadingSto && !loadingSto && !this.state.loading) {
            this.setState({
                list: this.state.list.map(sub => ({
                    ...sub,
                    // Refresh only the active subscription's row; preserve STO data the
                    // user loaded per-row via the file-search icon.
                    stoData: sub.id === clientInfo.user_subscription_id ? clientInfo : sub.stoData
                }))
            })
        }
    }

    // Safely parse a transaction_details JSON string; returns null on absence/invalid JSON.
    safeParse = value => {
        if (!value) return null
        try {
            return JSON.parse(value)
        } catch (e) {
            return null
        }
    }

    getHistory = () => {
        //  "subscription_status": "ACTIVE",
        //     "user_subscription_id": 55996,
        users
            .getSubscriptionHistory({ user_id: this.props.clientInfo.id })
            .then(res => {
                const { sub_history, qDate } = res.data
                const filteredHistory = sub_history.filter(({ status }) =>
                    ['ACTIVE', 'CANCELED', 'BLOCKED'].includes(status)
                )

                this.setState({ list: filteredHistory, qDate, loading: false })
            })
            .catch(error => {
                console.error('Failed to fetch subscription history', error)
                this.setState({ loading: false })
            })
    }
    getStoHistory = (user_id, status, user_sub_id) => {
        this.setState({ loadingStoRow: user_sub_id }, async () => {
            tranzila
                .getStoHistoryData({ user_id, status: status === 'CANCELED' ? 'inactive' : 'active', user_sub_id })
                .then(({ data }: any) => {
                    this.setState({
                        list: this.state.list.map(sub => ({
                            ...sub,
                            stoData: sub.id === user_sub_id ? data : sub.stoData
                        })),
                        loadingStoRow: 0
                    })
                })
                .catch(err => {
                    this.setState({
                        list: this.state.list.map(sub => ({
                            ...sub,
                            stoData:
                                sub.id === user_sub_id
                                    ? {
                                          sto_id: null,
                                          terminal_name: null,
                                          sto_status: null,
                                          err_key:
                                              (err && err.response && err.response.data && err.response.data.err_key) ||
                                              'NO_STO_DATA'
                                      }
                                    : sub.stoData
                        })),
                        loadingStoRow: 0
                    })
                })
        })
    }

    onRestore = userSubscription => {
        const { onConfirm } = this.props
        onConfirm(true, `SUBSCRIPTION_RECOVER,${userSubscription.id}`, userSubscription.prepayment_until)
    }

    getColumns = () => {
        const { clientInfo, loadingSto } = this.props
        const hasActiveSubscription = this.state.list.some(sub => ['ACTIVE', 'BLOCKED'].includes(sub.status))
        const hasActiveMonthsCoupon = this.state.list.some(sub => sub.transaction_details)
        const baseColumns: any[] = [
            {
                title: 'מינוי',
                key: 'subscription',
                align: 'right',
                render: (_, record) => {
                    const status = this.statuses[record.status]
                    const toolShow = record.stoData
                    // prettier-ignore
                    const { sto_id, terminal_name, sto_status, err_key, bank_name, bank_code, branch_code, account_number, expire_date, card_last_digits } = (record.stoData || {}) as any
                    const stoNull = !sto_id || !terminal_name || !sto_status
                    const stoExist = sto_id && terminal_name && sto_status

                    const err_by_key = {
                        OPPOSITE_STO_DATA: 'שימו לב! יש הו״ק פעילה',
                        MULTIPLE_ACTIVE_STO: 'שימו לב! יש 2 הו״ק פעילות',
                        NO_STO_DATA: 'אין הו״ק'
                    }
                    const error = stoErrKeyText(err_key, err_by_key, 'אין הו״ק')
                    const itemType = terminal_name === 'mediwhobk' ? 'bank' : 'credit-card'

                    return status ? (
                        <div>
                            {loadingSto && record.id === clientInfo.user_subscription_id ? (
                                <Spin size="small" style={{ marginLeft: '5px' }} />
                            ) : null}
                            <Tooltip placement="top" title={error}>
                                <Icon
                                    type="exclamation-circle"
                                    theme="twoTone"
                                    twoToneColor="red"
                                    style={{
                                        marginLeft: '5px',
                                        cursor: 'pointer',
                                        display: (toolShow || err_key) && stoNull ? 'inline-block' : 'none'
                                    }}
                                />
                            </Tooltip>
                            <Tooltip
                                placement="topRight"
                                title={
                                    itemType === 'bank' ? (
                                        <div>
                                            {bank_name ? <div>שם הבנק: {bank_name}</div> : null}
                                            <div>קוד בנק: {bank_code}</div>
                                            <div>מספר סניף: {branch_code}</div>
                                            <div>מספר חשבון: {account_number}</div>
                                        </div>
                                    ) : (
                                        <div>
                                            <div>תוקף כרטיס: {expire_date}</div>
                                            <div>ספרות אחרונות: {card_last_digits}</div>
                                        </div>
                                    )
                                }
                            >
                                <Icon
                                    type={itemType}
                                    theme="twoTone"
                                    style={{
                                        marginLeft: '5px',
                                        cursor: 'pointer',
                                        display: toolShow && stoExist && !loadingSto ? 'inline-block' : 'none'
                                    }}
                                />
                            </Tooltip>
                            {record.id !== clientInfo.user_subscription_id && !toolShow ? (
                                <Tooltip placement="top" title={'בדיקת אמצעי תשלום'}>
                                    <Icon
                                        type={this.state.loadingStoRow === record.id ? 'loading' : 'file-search'}
                                        style={{
                                            marginLeft: '5px',
                                            cursor: this.state.loadingStoRow === record.id ? 'not-allowed' : 'pointer',
                                            pointerEvents: this.state.loadingStoRow === record.id ? 'none' : 'auto'
                                        }}
                                        onClick={() => this.getStoHistory(clientInfo.id, record.status, record.id)}
                                    />
                                </Tooltip>
                            ) : null}
                            <span style={{ fontWeight: status.weight }}>{record.name}</span>
                        </div>
                    ) : null
                }
            },
            {
                title: 'מחיר',
                key: 'price',
                align: 'right',
                render: (_, record) => <span>{record.price}</span>
            },
            {
                title: 'סטטוס',
                key: 'status',
                align: 'right',
                render: (_, record) => {
                    const status = this.statuses[record.status]
                    return status ? (
                        <span style={{ color: status.color, fontWeight: status.weight }}>{status.text}</span>
                    ) : null
                }
            },
            {
                title: 'תאריך רכישה',
                key: 'created_at',
                align: 'right',
                render: (_, record) => <span>{moment(record.created_at).format('DD/MM/YY')}</span>
            },
            {
                title: 'תאריך ביטול',
                key: 'updated_at',
                align: 'right',
                render: (_, record) =>
                    record.status === 'CANCELED' ? <span>{moment(record.updated_at).format('DD/MM/YY')}</span> : ''
            },
            {
                title: 'שולם בתאריך',
                key: 'paid_at',
                align: 'right',
                render: (_, record) => {
                    const isPrepayment = record.prepayment_months && record.prepayment_until
                    return (
                        <span style={isPrepayment ? {} : { paddingRight: '19px' }}>
                            {isPrepayment ? (
                                <Tooltip
                                    placement="top"
                                    title={
                                        <div>
                                            <div>שולם מראש:</div>
                                            <div>{'מתאריך: ' + moment(record.created_at).format('DD/MM/YYYY')}</div>
                                            <div>{'עד: ' + moment(record.prepayment_until).format('DD/MM/YYYY')}</div>
                                        </div>
                                    }
                                >
                                    <Icon
                                        type="info-circle"
                                        theme="twoTone"
                                        style={{ marginLeft: '5px', cursor: 'pointer' }}
                                    />
                                </Tooltip>
                            ) : null}
                            {moment(record.paid_at).format('DD/MM/YY')}
                        </span>
                    )
                }
            }
        ]

        if (hasActiveMonthsCoupon) {
            baseColumns.push({
                title: 'תחילת תשלום (קופון)',
                key: 'coupon_exist',
                align: 'right',
                render: (_, record, index) => {
                    const recordParsed = this.safeParse(record.transaction_details)
                    if (recordParsed && recordParsed.paid_from) {
                        return <span>{moment(recordParsed.paid_from).format('DD/MM/YY')}</span>
                    }
                    return null
                }
            })
        }

        if (this.state.showRecoveryOption && !hasActiveSubscription) {
            baseColumns.push({
                title: '',
                key: 'restore',
                align: 'center',
                render: (_, record, index) => {
                    if (index === 0 && !hasActiveSubscription) {
                        return (
                            <Popconfirm
                                title="האם לבצע שחזור מנוי?"
                                onConfirm={async () => {
                                    const user_id = (this.props as any).clientInfo.id
                                    let freshStatus
                                    try {
                                        const res = await users.getClient({ user_id })
                                        freshStatus = res.data && res.data.subscription_status
                                    } catch (e) {
                                        freshStatus = null
                                    }
                                    if (freshStatus === 'ACTIVE' || freshStatus === 'BLOCKED') {
                                        alertPopup({
                                            type: 'alert',
                                            title: 'המנוי כבר פעיל',
                                            body: 'לא ניתן לשחזר את המנוי מכיוון שהוא כבר פעיל.'
                                        })
                                        return
                                    }
                                    this.onRestore(record)
                                }}
                                okText="כן"
                                cancelText="לא"
                            >
                                <Button disabled={loadingSto} type="primary">
                                    שחזור מנוי
                                </Button>
                            </Popconfirm>
                        )
                    }
                    return null
                }
            })
        }

        return baseColumns
    }

    render() {
        const { loading, list, qDate } = this.state

        return (
            <Card
                className="subscription-history"
                title={
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <span>היסטוריית רכישות</span>
                        {qDate && (
                            <span>
                                <strong>ת.קובע לת.אכשרה: </strong>
                                {`${moment(qDate).format('DD/MM/YY')}`}
                            </span>
                        )}
                    </div>
                }
                headStyle={{ backgroundColor: '#dadce0' }}
            >
                {loading ? (
                    <Spin />
                ) : list.length ? (
                    <Table
                        columns={this.getColumns()}
                        rowKey="id"
                        dataSource={list}
                        pagination={list.length < 6 ? false : { pageSize: 5 }}
                    />
                ) : (
                    ''
                )}
            </Card>
        )
    }
}

export default SubscriptionHistory
